/**
 * Invoice Entity Definition
 */
import { InvoiceRelationSchema } from "../schemas/relations";
import { ChargeEntityDef, RefundEntityDef } from "./charge.entity";
import { defineEntity } from "./core";
import { getLazyUserEntityDef } from "./lazy-refs";
import { PayoutEntityDef } from "./payout.entity";
export const InvoiceEntityDef = defineEntity({
    name: "invoice",
    schema: InvoiceRelationSchema,
    relations: {
        charge: { type: "one", entity: () => ChargeEntityDef },
        refund: { type: "one", entity: () => RefundEntityDef },
        payout: { type: "one", entity: () => PayoutEntityDef },
        issuer: { type: "one", entity: getLazyUserEntityDef },
        recipient: { type: "one", entity: getLazyUserEntityDef },
        user: { type: "one", entity: getLazyUserEntityDef },
    },
});
